import React from "react";
import PropTypes from "prop-types";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import TableReportes from "./components/TableReportes";

const Reportes = ({ reportId = 1, reportName = "RejectedStep", title = "Pasos rechazados" }) => (
  <DashboardLayout>
    <DashboardNavbar />
    <MDBox mt={2} mb={0}>
      <TableReportes key={reportId} reportId={reportId} reportName={reportName} title={title} />
    </MDBox>
  </DashboardLayout>
);
Reportes.propTypes = {
  reportId: PropTypes.number,
  reportName: PropTypes.string,
  title: PropTypes.string,
};
export default Reportes;
